import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

export function useAtsStageRoutingRules(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.ats_stage_routing_rules)
  );
}
